<div id="ui-view" [ngClass]="{ 'loding-ui-view': showloding }">
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-lg-12 headboxes">
        <div class="card p-0">
          <div class="card-block p-0">
            <div
              class="heading-box"
              style="background-image: url(assets/img/blog.png)"
            >
              <div class="row align-items-center">
                <div class="col-md-3">
                  <div class="pagename">
                    <h3 class="card-title">Users who used Smart Match</h3>
                  </div>
                </div>
                <div class="col-md-1">
                  <div class="total-count">
                    <h5 class="m-0">Total</h5>
                    <h2>{{ totalSmartMatch ? totalSmartMatch : 0 }}</h2>
                  </div>
                </div>

                <div class="col-md-8 text-end">
                  <div class="row align-items-end justify-content-end">
                    <div class="col-auto">
                      <div
                        class="row justify-content-around align-items-end position-relative searchx"
                      >
                        <div class="col-auto px-1">
                          <div class="form-group position-relative m-0">
                            <label for="" class="font-weight-normal m-0"
                              >From Date</label
                            >
                            <input
                              type="date"
                              class="form-control"
                              [max]="today"
                              (keydown)="blockTyping($event)"
                              autocomplete="off"
                              novalidate
                              name="startDate"
                              placeholder="Select Start Date"
                              [(ngModel)]="startDate"
                            />
                            <small
                              *ngIf="isSubmitted && !startDate && !dateInvalid"
                              class="text-danger position-absolute"
                              >From Date is required.</small
                            >
                          </div>
                        </div>

                        <div class="col-auto px-1">
                          <div class="form-group position-relative m-0">
                            <label for="" class="font-weight-normal m-0"
                              >To Date</label
                            >
                            <input
                              type="date"
                              class="form-control"
                              [max]="today"
                              (keydown)="blockTyping($event)"
                              autocomplete="off"
                              novalidate
                              name="endDate"
                              [(ngModel)]="endDate"
                              placeholder="Select End Date"
                            />
                            <small
                              *ngIf="isSubmitted && !endDate && !dateInvalid"
                              class="text-danger position-absolute"
                              >To Date is required.</small
                            >
                          </div>
                        </div>

                        <div class="col-auto px-1">
                          <button
                            class="border-0 cross-icon1"
                            (click)="onSearch()"
                          >
                            <i class="fa fa-search" aria-hidden="true"></i>
                          </button>
                        </div>

                        <div class="col-auto px-1">
                          <button
                            class="border-0 cross-icon1"
                            (click)="onReset()"
                          >
                            <i class="fa fa-refresh" aria-hidden="true"></i>
                          </button>
                        </div>

                        <small
                          *ngIf="
                            isSubmitted && dateInvalid && startDate && endDate
                          "
                          class="text-danger d-block text-center"
                          style="
                            position: absolute;
                            bottom: -20px;
                            margin-left: -50px;
                          "
                        >
                          Please ensure the From Date is earlier than or equal
                          to the To Date
                        </small>
                      </div>
                    </div>

                    <div class="col-auto px-1">
                      <div class="excel">
                        <button
                          type="button"
                          [disabled]="!exl"
                          class="btn btn-primary addbtn"
                          (click)="exportToExcel()"
                        >
                          <i class="fa fa-file-excel-o"></i>&nbsp; Export
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12">
        <div class="card">
          <div class="card-block">
            <div id="table" class="table-responsive">
              <table
                datatable
                id="smart_match"
                [dtOptions]="dtOptions"
                [dtTrigger]="dtTrigger"
                class="table"
                width="100%"
              >
                <thead>
                  <tr>
                    <th>#Sl</th>
                    <th style="width: 25%">Name</th>
                    <th>Gender</th>
                    <th>Language</th>
                    <th>State</th>
                    <th>City</th>
                    <th>Stage of Enterprise</th>
                    <th>Mode of Engagement</th>
                  </tr>
                </thead>

                <tbody *ngIf="mentorshipSmartMatchArr?.length != 0">
                  <tr
                    *ngFor="let item of mentorshipSmartMatchArr; let i = index"
                    [attr.data-index]="i"
                  >
                    <td>{{ i + 1 }}</td>
                    <td style="width: 25%">{{ item.user_name }}</td>
                    <td>{{ item.mentor_gender ? item.mentor_gender : "-" }}</td>
                    <td>{{ item.language ? item.language : "-" }}</td>
                    <td>{{ item.state_name ? item.state_name : "-" }}</td>
                    <td>{{ item.city_name ? item.city_name : "-" }}</td>
                    <td>
                      {{
                        item.stage_of_enterprise_name
                          ? item.stage_of_enterprise_name
                          : "-"
                      }}
                    </td>
                    <td>
                      {{
                        item.mode_of_engagement ? item.mode_of_engagement : "-"
                      }}
                    </td>
                  </tr>
                </tbody>

                <tbody *ngIf="mentorshipSmartMatchArr?.length == 0">
                  <tr>
                    <td colspan="8" class="no-data-available text-center">
                      No data available!
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
